import React, {useEffect} from 'react';
import {connect} from 'react-redux';
import {eSimSaleType} from '../Esim/esimEnums';
import SaleFooter from '../SaleFooter/SaleFooter';
import {showAppLoader, hideAppLoader} from '../../../Shared/Loader/LoaderSlice';
import ProviderManager from '../../../../provider/providerManager';
import {getRecaptchaToken} from '../../../../utilities/recaptcha/recaptcha';
import useExtendedEffect from '../../../../utilities/hooks/useExtendedEffect';
import UserAddress from '../UserAddress/UserAddress';
import {
    goToPage,
    reportAnalytics,
    setError,
    setSelectedAddress,
    setBan,
    setCustomerEmail,
    setFlowType,
    setIsUserAddressLoaded,
    setIsOtherAddress,
    setIsSkipToNewCustomer,
    setUserAddresses,
    setIsCustomerExposureSuccess,
    setNvIipSeq,
    setAccountInfo
} from '../saleBlockSlice';
import {dwhThirdPartyConsentCheckboxDisplay} from "../../ChangePricePlanBlock/reports/dwhReports";

const UserAddressPage = (props) => {
    let saleType = props.saleType;
    const isDisplayCheckboxReceivingAd = props.showCollaborationApproval;

    useEffect(() => {
        let eventLabel = props.productsInfo.selectedProducts ? props.productsInfo.selectedProducts[0]?.name : '';
        switch (saleType) {
            case 'tv':
                props.reportAnalytics({
                    eventCategory: 'tv_newsale_process',
                    eventAction: 'visibility_9',
                    eventLabel: eventLabel
                });
                break;
            case 'cellular':
                props.reportAnalytics({
                    eventCategory: 'cellular_newsale_process',
                    eventAction: 'visibility_10',
                    eventLabel: 'screen_5'
                });
                break;
            case 'internet':
                props.reportAnalytics({
                    eventCategory: 'fiber_newsale_process',
                    eventAction: 'visibility_25',
                    eventLabel: eventLabel
                });
                break;
        }
        if (isDisplayCheckboxReceivingAd) {
            dwhThirdPartyConsentCheckboxDisplay(props.personalInfo.firstName + " " + props.personalInfo.lastName, props._authentication.loginData.userDetails.contactNumber, props.personalInfo.id, "מכר " + props.saleType)
        }
    }, []);

    useExtendedEffect((runSideEffects) => {
        if (runSideEffects()) {
        }

        async function fetchData() {
            const isBanPackage = props.service.minimumProducts > 1;
            const isCustomerBasedPackage = props.productsInfo.selectedProducts[0]?.isCustomerBasedPackage;
            const productMakat = props.productsInfo.selectedProducts[0]?.productMakat;
            const makat = productMakat && productMakat != '' ? productMakat : '0';
            const isFamilyPackage = props.isFamilyPackage != null ? props.isFamilyPackage : false;
            const userAddresses = await getUserAddresses(props.saleType, isBanPackage, isCustomerBasedPackage, makat, isFamilyPackage);
            props.setUserAddresses({userAddresses: userAddresses});
            props.setIsUserAddressLoaded(true);

            const id = props._authentication.loginData.userDetails.IDNumber;
            const firstName = props._authentication.loginData.userDetails.firstName;
            const lastName = props._authentication.loginData.userDetails.lastName;

            let productType = '';
            switch (props.saleType) {
                case 'tv':
                case 'app':
                    productType = 'TV';
                    break;
                case 'cellular':
                    productType = 'CELLULAR';
                    break;
                case 'internet':
                    productType = 'INTERNET';
                    break;
            }
            let productCount = 0;
            let productAmount = 0;
            if (props.saleType == 'cellular') {
                productCount = props.productsInfo.selectedProducts.length;
                props.productsInfo.selectedProducts.map((product, key) => {
                    productAmount = parseFloat((productAmount + product.additionalPrice).toFixed(2));
                });
            }

            const isCustomerExposureSuccess = await getCustomerExposure(
                id,
                firstName,
                lastName,
                productType,
                productCount,
                productAmount,
                props.flowType,
                '0'
            );
            props.setIsCustomerExposureSuccess(isCustomerExposureSuccess);

            if (!isCustomerExposureSuccess) {
                console.info('isCustomerExposureSuccess', isCustomerExposureSuccess);
                props.setError({isDisplay: true, id: 1, isOpenWorkOrder: true});
                return;
            }

            if (props.saleType == 'cellular') {
                let storage = window.localStorage || window.sessionStorage;
                let reservePhoneNumbers = JSON.parse(storage.getItem('reservePhoneNumbers')) || [];

                const listPhoneNumbers = props.productsInfo.selectedProducts
                    .filter((x) => !reservePhoneNumbers.includes(x.newPhone))
                    .map((x) => x.newPhone);
                if (listPhoneNumbers && listPhoneNumbers.length > 0) {
                    const isSuccess = await reservePhoneNumber(id, listPhoneNumbers);
                    if (isSuccess) {
                        reservePhoneNumbers.push(...listPhoneNumbers);
                        storage.setItem('reservePhoneNumbers', JSON.stringify(reservePhoneNumbers));
                    } else {
                        props.setError({isDisplay: true, id: 34, isOpenWorkOrder: true});
                        return;
                    }
                }
            }
        }

        fetchData();
    }, []);

    useExtendedEffect(
        (runSideEffects) => {
            if (runSideEffects()) {
            }

            if (props.isSkipToNewCustomer) {
                props.setFlowType({flowType: 'newCustomer'});
                switch (props.saleType) {
                    case 'tv':
                        //props.goToPage(props.isOtherAddress ? {page: 'technicianPage', percent: 55} : {page: 'addressFormPage', percent: 27});
                        if (props.isOtherAddress) {
                            if (props.configuration.isAllowTechnitian) {
                                props.goToPage({page: 'technicianPage', percent: 55});
                            } else {
                                props.goToPage({page: 'emailPage', percent: 55});
                            }
                        } else {
                            props.goToPage({page: 'addressFormPage', percent: 27});
                        }
                        break;
                    case 'cellular':
                        //props.goToPage(props.isOtherAddress ? {page: 'deliveryAddressPage', percent: 55} : {page: 'addressFormPage', percent: 30});
                        if (props.isOtherAddress) {
                            if (props.configuration.isAllowDelivery && props.esim?.saleType != eSimSaleType.eSimOnly) {
                                props.goToPage({page: 'deliveryAddressPage', percent: 56});
                            } else {
                                props.goToPage({page: 'emailPage', percent: 70});
                            }
                        } else {
                            props.goToPage({page: 'addressFormPage', percent: 30});
                        }
                        break;
                    case 'internet':
                        props.goToPage({page: 'personalInfoPage', percent: 70});
                        break;
                }
            }
        },
        [props.isSkipToNewCustomer]
    );

    if (!props.isUserAddressLoaded) {
        return null;
    }

    //page params
    let isDisplayFooter = false;
    let btnText = 'המשך';
    let currentPageFunction = null;
    let totalPrice = null;
    let priceText = 'לחודש';
    let formid = 'sale';

    let currentPageView = null;
    //page params

    let title = '';
    switch (saleType) {
        case 'tv':
            title = `איפה תרצו להתקין את ${window.Config.brand_Name_HE} טיוי?`;
            break;
        case 'cellular':
            title = 'לאיזה חשבון לשייך את החבילה?';
            break;
        case 'internet':
            title = `לאיזה חשבון נשייך את ${window.Config.brand_Name_HE} פייבר?`;
            break;
    }

    let currentPageHeadline = (
        <div className='page-headline-wrapper'>
            <h1 className='sale-title'> {props.configuration.welcomeText} </h1>
            <h1 className='sale-title-big'> {title} </h1>
        </div>
    );

    if (props.userAddresses != null && props.userAddresses.length > 0) {
        currentPageView = (
            <UserAddress
                userAddresses={props.userAddresses}
                onSelectUserAddress={handleUserAddressPageContinue}
                isDisplaySimActivation={props.productsInfo.baseProduct.isDisplaySimActivation}
                isEsimOnly={props.esim?.saleType && props.esim?.saleType == eSimSaleType.eSimOnly}
                isDisplayCheckboxReceivingAd={isDisplayCheckboxReceivingAd}
            />
        );
    } else {
        props.setIsSkipToNewCustomer(true);
    }

    async function handleUserAddressPageContinue(userAddress) {
        let eventLabel = props.productsInfo.selectedProducts ? props.productsInfo.selectedProducts[0]?.name : '';
        switch (saleType) {
            case 'tv':
                props.reportAnalytics({
                    eventCategory: 'tv_newsale_process',
                    eventAction: userAddress.isOtherAddress ? 'click_12' : 'click_11',
                    eventLabel: eventLabel,
                });
                break;
            case 'cellular':
                props.reportAnalytics({
                    eventCategory: 'cellular_newsale_process',
                    eventAction: 'click_22',
                    eventLabel: userAddress.isOtherAddress ? 'new address' : 'my address',
                });
                break;
            case 'internet':
                props.reportAnalytics({
                    eventCategory: 'fiber_newsale_process',
                    eventAction: 'click_34',
                    eventLabel: eventLabel
                });
                break;
        }

        if (userAddress.isOtherAddress) {
            props.setIsOtherAddress(true);
            props.setIsSkipToNewCustomer(true);
            props.setSelectedAddress({selectedAddress: userAddress.address});
            return;
        } else {
            props.setBan({ban: userAddress.userDetails.ban});
            props.setCustomerEmail({email: userAddress.userDetails.email});

            const accountInfo = {
                accountType: userAddress.userDetails.accountType,
                accountMidType: userAddress.userDetails.accountMidType,
                accountSubType: userAddress.userDetails.accountSubType,
                paymentToken: userAddress.userDetails.paymentToken,
            };
            props.setAccountInfo({accountInfo: accountInfo});

            if (saleType == 'internet') {
                const ban = userAddress.userDetails.ban;

                //---------- createFiberSequence ----------
                const nvIipSeq = await createFiberSequence(userAddress.userDetails.ban);
                props.setNvIipSeq(nvIipSeq);
                const isCreateFiberSequence = nvIipSeq != '';
                if (!isCreateFiberSequence) {
                    props.setError({isDisplay: true, id: 39});
                    return;
                }
                //---------- createFiberSequence ----------

                if (props.selectedAddress.infrastructure.tashtitType == 'FIBER' || props.selectedAddress.infrastructure.tashtitType == 'IBC') {
                    //-------------- preSaleCheck --------------
                    const cityCode = props.selectedAddress.city;
                    const cityName = props.selectedAddress.cityName;
                    const streetCode = props.selectedAddress.street;
                    const streetName = props.selectedAddress.streetName;
                    const houseNum = props.selectedAddress.home;
                    const apartment = props.selectedAddress.apartment;
                    const letter = props.selectedAddress.enter;

                    const internalRequestId = await preSaleCheck(
                        ban,
                        nvIipSeq,
                        cityCode,
                        cityName,
                        streetCode,
                        streetName,
                        houseNum,
                        apartment,
                        letter
                    );
                    const isPreSaleCheckSuccess = internalRequestId != '';
                    if (!isPreSaleCheckSuccess) {
                        props.setError({isDisplay: true, id: 37});
                        return;
                    }
                    //-------------- preSaleCheck --------------

                    //------------ createFiberOrder ------------
                    const bodyTo = props.selectedAddress.infrastructure.tashtitType == 'IBC' ? 'BC' : 'FB';
                    const firstName = props.personalInfo.firstName;
                    const lastName = props.personalInfo.lastName;
                    const identity = props.personalInfo.id;
                    const contactPhoneNumber = props.personalInfo.contactNumber;
                    const contactName2 = '';

                    const isCreateFiberOrderSuccess = await createFiberOrder(
                        bodyTo,
                        ban,
                        nvIipSeq,
                        internalRequestId,
                        lastName,
                        firstName,
                        identity,
                        contactPhoneNumber,
                        contactName2
                    );
                    if (!isCreateFiberOrderSuccess) {
                        props.setError({isDisplay: true, id: 41});
                        return;
                    }
                    //------------ createFiberOrder ------------
                }
            }
        }

        switch (saleType) {
            case 'tv':
                props.setSelectedAddress({selectedAddress: userAddress.address});
                let pageData = {};
                if (!props.configuration.isAllowTechnitian && !props.configuration.isAllowDelivery) {
                    pageData = {page: 'otpVerifyPhone', percent: 55};
                }
                if (props.configuration.isAllowDelivery) {
                    pageData = {page: 'deliveryAddressPage', percent: 55};
                }
                if (props.configuration.isAllowTechnitian) {
                    pageData = {page: 'technicianPage', percent: 55};
                }
                props.goToPage(pageData);
                break;
            case 'cellular':
                props.setSelectedAddress({selectedAddress: userAddress.address});
                if (props.configuration.isAllowDelivery && props.esim?.saleType != eSimSaleType.eSimOnly) {
                    props.goToPage({page: 'deliveryAddressPage', percent: 56});
                } else {
                    props.goToPage({page: 'emailPage', percent: 70});
                }
                break;
            case 'internet':
                props.goToPage({page: 'emailPage', percent: 60});
                break;
        }
    }

    async function getUserAddresses(saleType, isBanPackage, isCustomerBasedPackage, productMakat, isFamilyPackage) {
        props.showAppLoader();
        try {
            const result = await ProviderManager.getProviderData('getCustomerAddresses', [
                saleType.toUpperCase(),
                isBanPackage,
                isCustomerBasedPackage,
                productMakat,
                isFamilyPackage
            ]);
            return result.Body;
        } catch (error) {
            return null;
        } finally {
            props.hideAppLoader();
        }
    }

    //667
    async function getCustomerExposure(id, firstName, lastName, productType, productCount, productAmount, flowType, otpPhone) {
        const captchaToken = await getRecaptchaToken('getCustomerExposure');
        if (captchaToken == undefined || captchaToken == null || captchaToken == '') {
            return;
        }

        props.showAppLoader();
        try {
            const result = await ProviderManager.getProviderData('CustomerExposure', [
                id,
                firstName,
                lastName,
                productType,
                productCount,
                productAmount,
                captchaToken,
                flowType,
                otpPhone,
            ]);
            console.info('getCustomerExposure', result);
            const isSuccess = result.Body.returnCode == '00' && result.Body.nonSeparDepos == '0';
            return isSuccess;
        } catch (error) {
            console.info('getCustomerExposure', error);
            return false;
        } finally {
            props.hideAppLoader();
        }
    }

    //024
    async function reservePhoneNumber(idNumber, listPhoneNumbers) {
        props.showAppLoader();
        try {
            const reservePhoneNumber = {
                IdNumber: idNumber,
                ListPhoneNumbers: listPhoneNumbers,
            };
            const result = await ProviderManager.getProviderData('reservePhoneNumber', reservePhoneNumber);
            const isSuccess = result && result.Body && result.Body.isSuccess;
            return isSuccess;
        } catch (error) {
            return false;
        } finally {
            props.hideAppLoader();
        }
    }

    //448
    async function createFiberSequence(ban) {
        props.showAppLoader();
        try {
            const fiberSequence = {
                personId: ban,
                nvIdType: 'BAN',
            };
            console.info('createFiberSequence', JSON.stringify(fiberSequence));
            const result = await ProviderManager.getProviderData('createFiberSequence', fiberSequence);
            console.info('createFiberSequence', result);

            const isSuccess = result.Body.isSuccess;
            if (isSuccess) {
                return result.Body.nvIipSeq;
            }
            return '';
        } catch (error) {
            console.info(error);
            props.setError({isDisplay: true, id: 38});
            return '';
        } finally {
            props.hideAppLoader();
        }
    }

    //750//1421
    async function preSaleCheck(ban, nvIipSeq, cityCode, cityName, streetCode, streetName, houseNum, apartment, letter) {
        const captchaToken = await getRecaptchaToken('preSaleCheck');
        if (captchaToken == undefined || captchaToken == null || captchaToken == '') {
            return;
        }

        props.showAppLoader();
        try {
            const preSale = {
                ban: ban,
                nvIipSeq: nvIipSeq,
                cityCode: cityCode,
                cityName: cityName,
                streetCode: streetCode,
                streetName: streetName,
                houseNum: houseNum,
                apartment: apartment,
                capchaValue: captchaToken,
                letter: letter,
            };
            console.info('preSaleCheck', JSON.stringify(preSale));
            const result = await ProviderManager.getProviderData('preSaleCheck', preSale);
            console.info('preSaleCheck', result);

            const isSuccess = result.Body.isSuccess;
            const internalRequestId = isSuccess ? result.Body.internalRequestId : '';
            return internalRequestId;
        } catch (error) {
            console.info(error);
            props.setError({isDisplay: true, id: 38});
            return '';
        } finally {
            props.hideAppLoader();
        }
    }

    //750//1420
    async function createFiberOrder(bodyTo, ban, seq, internalRequestId, lastName, firstName, identity, contactPhoneNumber, contactName2) {
        props.showAppLoader();
        try {
            const fiberOrder = {
                BodyTo: bodyTo,
                Ban: ban,
                Seq: seq,
                InternalRequestId: internalRequestId,
                LastName: lastName,
                FirstName: firstName,
                Identity: identity,
                ContactPhoneNumber: contactPhoneNumber,
                ContactName2: contactName2,
            };
            console.info('createFiberOrder', JSON.stringify(fiberOrder));
            const result = await ProviderManager.getProviderData('createFiberOrder', fiberOrder);
            console.info('createFiberOrder', result);

            const isSuccess = result.Body.isSuccess;
            return isSuccess;
        } catch (error) {
            console.info(error);
            props.setError({isDisplay: true, id: 40});
            return false;
        } finally {
            props.hideAppLoader();
        }
    }

    function handleSubmit(event) {
        event.preventDefault();
    }

    return (
        <div className='slideAnimation'>
            {currentPageHeadline}
            <div className='sale-page-content'>
                <form id='sale' onSubmit={handleSubmit}>
                    {' '}
                    {currentPageView}{' '}
                </form>
                <SaleFooter
                    isDisplayFooter={isDisplayFooter}
                    btnText={btnText}
                    onclick={currentPageFunction}
                    price={totalPrice}
                    priceText={priceText}
                    formid={formid}
                />
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        saleType: state.saleBlock.saleType,
        flowType: state.saleBlock.flowType,
        page: state.saleBlock.page,
        percent: state.saleBlock.percent,
        progressBarPoints: state.saleBlock.progressBarPoints,
        configuration: state.saleBlock.epiServer.configuration,
        service: state.saleBlock.epiServer.service,
        totalPrice: state.saleBlock.totalPrice,
        isUserAddressLoaded: state.saleBlock.isUserAddressLoaded,
        userAddresses: state.saleBlock.userAddresses,
        productsInfo: state.saleBlock.productsInfo,
        selectedAddress: state.saleBlock.selectedAddress,
        personalInfo: state.saleBlock.personalInfo,
        isCustomerConnectedToIbc: state.saleBlock.isCustomerConnectedToIbc,
        technicianArrivalTimeIbc: state.saleBlock.technicianArrivalTimeIbc,
        isSkipToNewCustomer: state.saleBlock.isSkipToNewCustomer,
        isOtherAddress: state.saleBlock.isOtherAddress,
        esim: state.saleBlock.esim,
        isFamilyPackage: state.saleBlock.isFamilyPackage,
        showCollaborationApproval: state.saleBlock.checkUser?.showCollaborationApproval,
        //other states
        _authentication: state.authentication,
        _address: state.addressForm.form,
    };
};

const mapDispatchToProps = {
    goToPage,
    reportAnalytics,
    setError,
    setSelectedAddress,
    setBan,
    setCustomerEmail,
    setFlowType,
    setIsUserAddressLoaded,
    setIsOtherAddress,
    setIsSkipToNewCustomer,
    setUserAddresses,
    setIsCustomerExposureSuccess,
    setNvIipSeq,
    setAccountInfo,

    //loader
    showAppLoader,
    hideAppLoader,
};

export default connect(mapStateToProps, mapDispatchToProps)(UserAddressPage);
